import { type MoneymapItem, type ShopSections } from "@src/api";
import { type ShopZoneExtended } from "@src/store";

export type MoneymapItemWithTitle = MoneymapItem & { title?: string };

export const fillSectionMoneymap = (
  moneymap_list: MoneymapItem[],
  zone_map: Record<string, ShopZoneExtended>,
  map_section: Partial<Record<ShopSections | 'NOT_ZONE', MoneymapItemWithTitle>>
) => {
  const result = { ...map_section };

  moneymap_list.forEach((item) => {
    if (!item.is_zone) {
      result.NOT_ZONE = { ...item }
    } else {
      const zone = zone_map[item.zone_id];

      if (zone) {
        result[zone.title] = { ...item, title: zone.title };
      }
    }
  });

  return result;
};